// extracted by mini-css-extract-plugin
export var acitonButtons = "_hk-0";
export var additionalIcon = "_hk-f";
export var block = "_hk-1";
export var blockContent = "_hk-7";
export var blockDescription = "_hk-8";
export var blockIcon = "_hk-9";
export var blockTitle = "_hk-6";
export var border = "_hk-a";
export var center = "_hk-l";
export var edge = "_hk-b";
export var edgeLabel = "_hk-c";
export var edgePath = "_hk-d";
export var error = "_hk-e";
export var flowchart = "_hk-g";
export var flowchartContent = "_hk-h";
export var highlighted = "_hk-3";
export var hover = "_hk-4";
export var icon = "_hk-i";
export var left = "_hk-m";
export var navButton = "_hk-j";
export var navButtons = "_hk-k";
export var right = "_hk-n";
export var selected = "_hk-2";
export var small = "_hk-5";